export default {
    'nav.news.detai.title':'Detail',
    'asset.stock.purchare.detail.add.optional':'Succeed',
    'asset.stock.purchare.detail.delete.optional':'Removed',
    'news.days.ago':' days ago',
    'news.hours.ago':' hours ago',
    'news.minutes.ago':' minutes ago',
    'news.seconds.ago':' seconds ago',

}